import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import AnimatedLayout from '../../components/animatedLetters/AnimatedLayout';
import ProjectItem from '../../components/portfolio/ProjectItem';
import Sidebar from '../../components/sidebar/Sidebar';
import AgbaContext from '../../context/agba/agbaContext';
import { ProjectLayoutDiv } from './projectLayoutStyle';
import useElementOnScreen from '../../utils/useElementOnScreen';

const ProjectLayoutPage = () => {
  const agbaContext = useContext(AgbaContext);
  const { sideBar } = agbaContext;

  const [itemRef, isVisible] = useElementOnScreen({
    root: null,
    rootMargin: '0px',
    threshold: 0.05,
  });

  return (
    <ProjectLayoutDiv sideBar={sideBar} isVisible={isVisible}>
      <Sidebar />
      <div className='top-gradient gradient'></div>
      <div className='text-zone' ref={itemRef}>
        <h1>
          <AnimatedLayout
            letterClass={'text-animate-hover'}
            strArray={[
              'M',
              'y',
              ' ',
              ' ',
              'p',
              'o',
              'r',
              't',
              'f',
              'o',
              'l',
              'i',
              'o',
            ]}
            idx={30}
          />
        </h1>
        <p>
          This is a gallery of recent interesting projects selected by me.
          Collaboratively built with amazing software engineers around the
          globe. Interested in viewing more of my projects? visit my{' '}
          <Link to='/portfolio'>portfolio</Link> page.
        </p>
      </div>
      <ProjectItem />
    </ProjectLayoutDiv>
  );
};

export default ProjectLayoutPage;
